var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6439 12.8375L17.1174 9.30452H13.5844V7.0281C13.5844 6.42712 13.6936 6.00826 13.8939 5.7533C14.1671 5.44371 14.6588 5.2798 15.3144 5.2798H17.2084V2.0746C16.4617 2.00175 15.5512 1.96533 14.4585 1.96533C13.0926 1.96533 11.9817 2.36598 11.1258 3.18549C10.2881 3.9868 9.85102 5.15232 9.85102 6.66387V9.30452H6.7915V12.8375H9.85102V22.0343H13.5479V12.8375H16.6439Z"
  })));
};
export default SvgIconFacebook;